export interface IPaging {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
}

export interface IRequestPaging {
  currentPage: number;
  itemsPerPage: number;
}

export enum Validity {
  OK = 'OK',
  ONLY_KWH_OR_MIN_PLUS_DELAY_FAILED = 'ONLY_KWH_OR_MIN_PLUS_DELAY_FAILED', // COMPLEO_01 || ALPITRONIC_01
  ONLY_KWH_FAILED = 'ONLY_KWH_FAILED', // ADSTEC_01  || WALLBE_ZAS_01 || WALLBE_XPAY_01
  UNKNOWN_BPO_ERROR = 'UNKNOWN_BPO_ERROR', // Generic station assignment validation error
  CPO_TARIFF_ID_NOT_SAME = 'CPO_TARIFF_ID_NOT_SAME',
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  TERMINAL_CLASS_MISMATCH = 'TERMINAL_CLASS_MISMATCH', // When trying to steal from different terminal class
}

export interface BusinessPartner {
  businessPartners: Partner[];
}

export interface Partner {
  id: string;
  name: string;
  inRolePaymentTerminalTenant: boolean;
}

export interface AddressFilter {
  country: string;
  city: string;
  zipCode: string;
  street: string;
}

export interface TerminalAssignMemberTO {
  stationUuids: string[];
}

export interface Filters {
  country: string;
  city: string;
  zipCode: string;
  streetSearchList: string[];
  page: number;
  pageSize: number;
  searchTerm: string;
}

export enum TerminalClass {
  INTEGRATED = 'INTEGRATED',
  VAYLENS_PAY = 'VAYLENS_PAY',
  XPAY = 'XPAY',
}
